module.exports = __webpack_public_path__ + "assets/kids/img/logo-email.6581a1a7.png";